import { useCallback, useEffect, useState } from 'react'
import { api } from '../api/client.js'

export interface MyCampaign {
  id: string
  name: string
}

export interface MyTeam {
  id: string
  name: string
  campaignId: string | null
}

export interface UseMyCampaignsTeamsResult {
  campaigns: MyCampaign[]
  teams: MyTeam[]
  loading: boolean
  error: string | null
  refetch: () => Promise<void>
}

export function useMyCampaignsTeams(fetchOnMount = false): UseMyCampaignsTeamsResult {
  const [campaigns, setCampaigns] = useState<MyCampaign[]>([])
  const [teams, setTeams] = useState<MyTeam[]>([])
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const refetch = useCallback(async (): Promise<void> => {
    setLoading(true)
    setError(null)
    try {
      const res = await api.get<{ campaigns: MyCampaign[]; teams: MyTeam[] }>('/agent/me/campaigns-teams')
      setCampaigns(res.campaigns ?? [])
      setTeams(res.teams ?? [])
    } catch (e) {
      setError(e instanceof Error ? e.message : 'Failed to fetch campaigns/teams')
      setCampaigns([])
      setTeams([])
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    if (fetchOnMount) void refetch()
  }, [fetchOnMount, refetch])

  return { campaigns, teams, loading, error, refetch }
}
